module.exports = __webpack_public_path__ + "static/media/woo5.53ae8bf5.png";